import { useEffect, useState, useCallback } from 'react';
import { authAPI } from '../lib/api';

export function GoogleSignInButton({ onSuccess, onError, text = 'signin_with' }) {
  const [clientId, setClientId] = useState('');
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    authAPI.googleClientId().then(res => {
      setClientId(res.data?.client_id || '');
    }).catch(() => {});
  }, []);

  const initializeGoogle = useCallback(() => {
    if (!clientId || !window.google?.accounts) return;
    try {
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: (response) => {
          if (response.credential) {
            onSuccess(response.credential);
          }
        },
      });
      window.google.accounts.id.renderButton(
        document.getElementById('google-signin-btn'),
        {
          theme: 'filled_black',
          size: 'large',
          width: '100%',
          text: text,
          shape: 'pill',
          logo_alignment: 'center',
        }
      );
    } catch (e) {
      console.error('Google init error:', e);
    }
  }, [clientId, onSuccess, text]);

  useEffect(() => {
    if (!clientId) return;

    if (window.google?.accounts) {
      initializeGoogle();
      return;
    }

    // Load Google Identity Services script
    if (!document.getElementById('google-gsi-script')) {
      const script = document.createElement('script');
      script.id = 'google-gsi-script';
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = () => {
        setLoaded(true);
        initializeGoogle();
      };
      script.onerror = () => {
        if (onError) onError('Failed to load Google Sign-In');
      };
      document.head.appendChild(script);
    } else {
      // Script already in DOM, wait for it
      const checkLoaded = setInterval(() => {
        if (window.google?.accounts) {
          clearInterval(checkLoaded);
          setLoaded(true);
          initializeGoogle();
        }
      }, 200);
      return () => clearInterval(checkLoaded);
    }
  }, [clientId, initializeGoogle, onError]);

  useEffect(() => {
    if (loaded && clientId) initializeGoogle();
  }, [loaded, clientId, initializeGoogle]);

  if (!clientId) return null;

  return (
    <div className="w-full" data-testid="google-signin-container">
      <div id="google-signin-btn" className="flex justify-center" />
    </div>
  );
}
